export interface TabItem {
  id: string;
  label: React.ReactNode;
  param?: string;
}

export interface TabsProps {
  tabs: TabItem[];
  activeId: string;
  onChange: (tabId: string) => void;
  className?: string;
  // 'underline' (default) is the underlined tab bar shared by DataBreachDetail's Breach
  // Details/Data Principals tabs, ConsentEdit, and Settings' tab switcher. 'pill' is the
  // bordered pill-group style used by PreviewNoticeModal's Email/SDK Preview switcher.
  variant?: 'underline' | 'pill';
}

// (see useTabParam for the common ?tab= query-param-synced case).
export const Tabs = ({ tabs, activeId, onChange, className, variant = 'underline' }: TabsProps) => {
  if (variant === 'pill') {
    return (
      <div className={`flex items-center border border-gray-200 rounded-lg p-1 w-fit ${className ?? ''}`}>
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            className={`px-3 py-1.5 w-40 text-sm rounded-md cursor-pointer transition-colors ${
              activeId === t.id ? 'bg-[#F4FAFB] text-[#3F707D] font-semibold' : 'text-gray-800'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={`flex items-center border-b border-gray-200 shrink-0 ${className ?? 'px-6'}`}>
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onChange(t.id)}
          className={`px-3 py-3.5 text-[13px] font-medium border-b-2 transition-colors cursor-pointer whitespace-nowrap -mb-px ${
            activeId === t.id
              ? 'border-[#3F707D] text-[#3F707D]'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
};
